import React, { useEffect, useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  PageWrapper,
  ProjectsGallery,
  SectionTitle,
} from '../../../components';
import { getProjects } from '../../../data/mock.data.projects';
import { Project } from '../../../models/Project';

const ProjectsSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [projects, setProjects] = useState<Project[]>([]);

  useEffect(() => {
    getProjects()
      .then((items: Project[]) => {
        setProjects(items);
      })
      .catch((err: unknown) => {
        // eslint-disable-next-line no-console
        console.error(
          'Failed to load projects from Cockpit:',
          err
        );

        setProjects([]);
      });
  }, []);

  const orderedProjects = useMemo<Project[]>(
    () => [...projects].reverse(),
    [projects]
  );

  const handleSeeAllProject = () => {
    navigate('/projects');
  };

  if (orderedProjects.length === 0) {
    return null;
  }

  return (
    <PageWrapper>
      <SectionTitle
        title={t('homepage.projects.title')}
        description={t('homepage.projects.description')}
      />

      <ProjectsGallery
        items={orderedProjects}
        buttonLabel={t('homepage.projects.buttonLabel')}
        onClick={handleSeeAllProject}
      />
    </PageWrapper>
  );
};

export default ProjectsSection;